import { FC, lazy } from 'react'; // import { useOurProfiler } from 'src/hooks/use-our-profiler';
import {
  StorageAllocationState,
  StorageOffersSearchParams,
  StorageOfferState,
} from 'src/apis/monolith/types';
import { PageSpinner } from 'src/components/spinner-container';
import { useStorageOffers } from 'src/pages/storage/offers/use-storage-offers';
import {
  QuickFilterValues,
  useStorageOffersParams,
} from 'src/pages/storage/offers/use-storage-offers-params';
import { useMemoOne } from 'use-memo-one';

const Page = lazy(() => import('./page'));

const offerStateMap: Record<QuickFilterValues, StorageOfferState[]> = {
  ALL: [],
  PENDING: [],
  DRAFT: ['DRAFT'],
  FINISHED: ['FINISHED'],
  OPEN_AND_PUBLISHED: ['OPEN', 'PUBLISHED'],
};

const allocationStateMap: Record<QuickFilterValues, StorageAllocationState[]> =
  {
    ALL: [],
    PENDING: ['AWAITING_ALLOCATION', 'ALLOCATIONS_UNCONFIRMED'],
    DRAFT: [],
    FINISHED: [],
    OPEN_AND_PUBLISHED: [],
  };

export const StorageOffers: FC = () => {
  const pageParams = useStorageOffersParams();

  const params = useMemoOne(() => {
    const params: StorageOffersSearchParams = {
      start: pageParams.value.start,
      pageSize: pageParams.value.pageSize,
      sortColumn: pageParams.value.sortColumn,
      sortAscending: pageParams.value.sortAscending,
      offerLabel: pageParams.value.offerLabel,
      storageLocationName: pageParams.value.storageLocationName,
      tsoShortName: pageParams.value.tsoShortName,
      productType: pageParams.value.productType,
      runtimeFrom: pageParams.value.runtimeFrom,
      runtimeTo: pageParams.value.runtimeTo,
      offerState: offerStateMap[pageParams.value.quickFilter],
      allocationState: allocationStateMap[pageParams.value.quickFilter],
      id: pageParams.value.id,
    };

    return params;
  }, [pageParams.value]);

  const storageOffers = useStorageOffers(params);

  if (!storageOffers.response) {
    return <PageSpinner />;
  }

  return <Page storageOffers={storageOffers} pageParams={pageParams} />;
};
